import { queryOptions, useSuspenseQuery } from "@tanstack/react-query";
import { fetchEnterpriseCustomerContext } from "../api/enterpriseClient";

export const customerContextQueryOptions = (externalCustomerId: string) =>
  queryOptions({
    queryKey: ["enterprise-customer-context", externalCustomerId],
    queryFn: () => fetchEnterpriseCustomerContext(externalCustomerId),
    staleTime: 5 * 60_000,
  });

export function useGetCustomerContext(externalCustomerId: string) {
  return useSuspenseQuery(customerContextQueryOptions(externalCustomerId));
}
